import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Papa from "papaparse";
import { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { api, superAdminReqConfig } from "../../include/api";
import "../../styles/Super.css";
import Flyout from "../common/Flyout";
import SuperAdminHeader from "./Header";
import FilterModal from "./FilterModal";

const Invoice = ({ from }) => {
    const [fetchLoading, setFetchLoading] = useState(true);
    const [invoiceData, setInvoiceData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [shippingDatas, setShippingDatas] = useState([]);
    const [settingsData, setSettingsData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [invObj, setInvObj] = useState(null);
    const [cusObj, setCusObj] = useState(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filters, setFilters] = useState({ fromDate: "", toDate: "", orderId: "", product: "", paymentMethod: "", status: "" });
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [selectQuery, setSelectQuery] = useState("");
    const [customer, setCustomer] = useState([])
    const [settings, setSettings] = useState([]);
    const prevQueryRef = useRef();

const [errors, setErrors] = useState({});

const handleSelectQueryChange = (query) => {
        setSelectQuery(query);
    };

    useEffect(() => {
        api.get('/settings/', superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setSettings(response.data.data)
            }
        }).catch(error => {
            setSettings([])
        }).finally()
    }, [])

    useEffect(() => {
        if (prevQueryRef.current !== selectQuery) {
            getCustomer(selectQuery);
            prevQueryRef.current = selectQuery;
        }
    }, [selectQuery]);

    const getCustomer = async (selectQuery) => {
        setFetchLoading(true);
        try {
            const response = await api.get(`/customer/search/?q=${selectQuery}`);
            console.log(response.data);  // Now you can access the data directly
            if (response.status === 200 && Array.isArray(response.data.data.customer)) {
                setCustomer(response.data.data.customer);
            }
        } catch (error) {
            console.error("Error fetching customer data:", error);
            setCustomer([]); // In case of an error, set the customer array to empty
        } finally {
            setFetchLoading(false);
        }
    };

    const dynamicFilters = [
        { key: "orderId", label: "Order ID", type: "text" },
        {
            key: "customerId", label: "Customer Name", type: "select", options: customer.map((c) => ({
                value: c.id,
                label: c.name
            }))
        },
        {
            key: "paymentMethod", label: "Payment Method", type: "select", options: settings.filter(f => f.head.toLowerCase().includes('payment')).map((p) => ({
                value: p.key,
                label: p.key
            }))
        },
    ];

    const [shippingData, setShippingData] = useState({
        trackingNumber: "",
        carrier: "",
        shippingStatus: "Shipped",
        shippingMethod: "",
        shippingCost: "",
        loadingCharge: "",
        unloadingCharge: "",
        address: "",
        city: "",
        state: ""
    });

    const [orderId, setOrderId] = useState(null);
    const getInvoice = (filterValues = {}) => {
        setFetchLoading(true);

        const todayDate = new Date().toISOString().split("T")[0];
        const yesterdayDate = new Date(Date.now() - 86400000).toISOString().split("T")[0];

        const queryParams = new URLSearchParams(filterValues).toString();

        const url = queryParams
            ? `/super_sales_invoice/?${queryParams}`
            : `/super_sales_invoice/?fromDate=${yesterdayDate}&toDate=${todayDate}&orderId=&customerId=&paymentMethod=`;

        api.get(url, superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setInvoiceData(response.data.data);
                setFilteredData(response.data.data);
            }
        }).catch(error => {
            setInvoiceData([]);
            setFilteredData([]);
        }).finally(() => setFetchLoading(false));
    };

    const handleApplyFilters = (appliedFilters) => {
        setFilters(appliedFilters);
        setIsModalOpen(false);
        getInvoice(appliedFilters);
    };

    useEffect(() => {
        api.get('/settings/', superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setSettingsData(response.data.data)
            }
        }).catch(error => {
            setSettingsData([])
        })
    }, [])

    const getShippingData = () => {
        api.get('/shipping/', superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setShippingDatas(response.data.data);
            }
        }).catch(error => {
            console.error("Failed to fetch shipping data", error);
        });
    };

    useEffect(() => {
        getInvoice();
        getShippingData();
    }, []);

    const toggleFlyout = (invoice, from) => {
        setIsFlyoutVisible(!isFlyoutVisible)
        if (from === 'invoice') {
            setInvObj(invoice)
            setCusObj(null)
        }
        else if (from === 'customer') {
            setCusObj(invoice)
            setInvObj(null)
        }
        else {
            setInvObj(null)
            setCusObj(null)
        }
    };

    // // Handle Search Filter
    // const handleSearch = (query) => {
    //     setSearchQuery(query);

    //     const filtered = invoiceData.filter((data) => {
    //         return (
    //             data.order_id?.toLowerCase().includes(query?.toLowerCase()) ||
    //             data.customer_name?.toLowerCase().includes(query?.toLowerCase()) ||
    //             data.payment_method?.toLowerCase().includes(query?.toLowerCase())
    //         );
    //     });

    //     setFilteredData(filtered);
    // };

    // const handleOpenModal = (id, address, city, state) => {
    const handleOpenModal = (id, customerId, address, city, state) => {
        setOrderId(id);
        setShippingData((prevData) => ({
            ...prevData,
            customerId: customerId,
            address: address,
            city: city,
            state: state
        }));
        setShowModal(true);
    };

const handleChange = (e) => {
  const { name, value } = e.target;

  setShippingData((prevData) => ({
    ...prevData,
    [name]: value
  }));

  // Clear the error for this field if value is not empty
  setErrors((prevErrors) => ({
    ...prevErrors,
    [name]: value.trim() === '' ? `${name} is required` : ''
  }));
};

    // const handleSubmit = () => {
    //     const data = {
    //         orderId,
    //         ...shippingData
    //     };
    //     api.post('/shipping/', data, superAdminReqConfig())
    //         .then(response => {
    //             if (response.status === 200) {
    //                 toast.success(response.message);
    //                 setShowModal(false);
    //                 getInvoice();
    //                 getShippingData()
    //             }
    //         })
    //         .catch(error => {
    //             console.error("Error while submitting shipping data", error);
    //         });
    // };

    const handleSubmit = () => {
    const newErrors = {};
    const requiredFields = {
        trackingNumber: 'Tracking Number',
        carrier: 'Carrier',
        shippingMethod: 'Shipping Method',
        shippingCost: 'Shipping Cost',
        loadingCharge: 'Loading Charge',
        unloadingCharge: 'Unloading Charge',
        address: 'Address',
        city: 'City',
        state: 'State',
    };

    Object.entries(requiredFields).forEach(([key, label]) => {
        if (!shippingData[key] || shippingData[key].toString().trim() === '') {
            newErrors[key] = `${label} is required`;
        }
    });

    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
    }

    setErrors({});
    const data = { orderId, ...shippingData };
    api.post('/shipping/', data, superAdminReqConfig())
        .then(response => {
            if (response.status === 200) {
                toast.success(response.message || 'Shipping details added');
                setShowModal(false);
                getInvoice();
                getShippingData();
            }
        })
        .catch(error => {
            console.error("Error while submitting shipping data", error);
            toast.error('Failed to submit shipping data');
        });
};


    // Handle Search Filter
    const handleSearch = (query) => {
        setSearchQuery(query);

        const filtered = invoiceData.filter((data) => {
            return (
                data.orderId?.toString().toLowerCase().includes(query?.toLowerCase()) ||
                data.name?.toLowerCase().includes(query?.toLowerCase()) ||
                data.paymentMode?.toLowerCase().includes(query?.toLowerCase())
            );
        });

        setFilteredData(filtered);
    };


    // PDF Download
    const downloadPDF = () => {
        const doc = new jsPDF();
        const title = "Invoice Report";

        doc.setFontSize(18);

        const pageWidth = doc.internal.pageSize.getWidth();
        const titleWidth = doc.getTextWidth(title);
        const titleX = (pageWidth - titleWidth) / 2;

        doc.text(title, titleX, 10);
        autoTable(doc, {
            head: [['S.No', 'Order Id', 'Order Date', 'Payment Method', 'Status', 'Total Amount', 'Address']],
            body: filteredData.map((od, i) => [
                i + 1,
                od.orderId,
                od.date,
                od.paymentMode,
                od.status,
                od.totalAmount,
                `${od.name}\nPhone no: ${od.phoneNumber}\n${od.address}\n${od.city}\n${od.state}`
            ])
        });
        doc.save('invoice.pdf');
    };


    // CSV Download
    const downloadCSV = () => {
        const csvData = filteredData.map((od, i) => ({
            'S.No': i + 1,
            'Order Id': od.orderId,
            'Order Date': od.date,
            'Payment Method': od.paymentMode,
            'Status': od.status,
            'Total Amount': od.totalAmount,
            'Address': `${od.name}, Phone no: ${od.phoneNumber}, ${od.address}, ${od.city}, ${od.state}`
        }));

        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoice.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

const handleClear = () => {
  setShippingData({
    trackingNumber: "",
    carrier: "",
    shippingStatus: "Shipped",
    shippingMethod: "",
    shippingCost: "",
    loadingCharge: "",
    unloadingCharge: "",
    address: "",
    city: "",
    state: ""
  });
  setErrors({});
};

    return <>
        <Flyout isVisible={isFlyoutVisible} onClose={() => toggleFlyout({})} orderId={invObj?.orderId} customerId={cusObj?.customerId}>
            {/* Content for Flyout */}
            {/* <p>Flyout content goes here!</p> */}
            {/* {invObj && <div><h4 className="my-2">Invoice Details</h4>
                <div className="card mt-2">
                    <label className="m-1">Order Id: {invObj.orderId}</label>
                    <label className="m-1">Order Date: {invObj.date}</label>
                    <label className="m-1">Customer: {invObj.name}</label>
                    <label className="m-1">Status: {invObj.status}</label>
                    <label className="m-1">Payment Method: {invObj.paymentMode}</label>
                    <label className="m-1">Total Amount: {invObj.totalAmount}</label>
                </div></div>}

            {cusObj && <div><h4 className="my-2">Customer Details</h4>
                <div className="card mt-2">
                    <label className="m-1">Customer Name: {cusObj?.name}</label>
                    <label className="m-1">Address: {cusObj?.address || ''},<br />{cusObj.city || ''},<br />{cusObj.state || ''},<br />{cusObj.phoneNumber || ''}<br /></label>
                    <label className="m-1">Loyal Points: 5</label>
                </div></div>} */}

        </Flyout >
        {/* Filter Modal */}
        <FilterModal
            show={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onApply={handleApplyFilters}
            dynamicFilters={dynamicFilters}
            initialFilters={filters}
            selectQuery={selectQuery}
            setSelectQuery={handleSelectQueryChange}
        />
        <SuperAdminHeader>
            <div className="fixed-top-bar">
                <div className="card">
                    <h5 className="m-2">Invoice</h5>
                    <div className="card-body">
                        {/* Search Filter */}
                        <div className="card my-4 row">
                            <div className="row ">
                                <div className="search-section m-3 col-8">
                                    {/* Checkbox for toggling direct search */}
                                    <div className="form-check mb-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="directSearchCheckbox"
                                            checked={isCheckboxChecked}
                                            onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
                                        />
                                        <label className="form-check-label" htmlFor="directSearchCheckbox">
                                            Direct Search (Filter Table Data)
                                        </label>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by Order ID, Customer Name, or Payment Method"
                                        value={searchQuery}
                                        onChange={isCheckboxChecked ? (e) => handleSearch(e.target.value) : undefined}
                                        onClick={!isCheckboxChecked ? () => setIsModalOpen(true) : undefined}
                                    />
                                    <div className="mt-2">
                                    <small>{filteredData.length} results found</small>
                                </div>
                                </div>
                                <div className="col m-3 ">
                                    {from === 'reports' && (
                                        <>
                                            <button
                                                className="btn btn-success mx-2"
                                                onClick={downloadPDF}
                                                style={{ fontSize: "14px" }}
                                            >
                                                <i className="fa-solid fa-download"></i> PDF
                                            </button>
                                            <button
                                                className="btn btn-success mx-2"
                                                onClick={downloadCSV}
                                                style={{ fontSize: "14px" }}
                                            >
                                                <i className="fa-solid fa-download"></i> CSV
                                            </button>
                                        </>
                                    )}

                                </div>
                            </div>

                            <div className="table-wrapper">
                                {fetchLoading ? (
                                    <p>Loading...</p>
                                ) : (
                                    <table className="table ">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Order Id</th>
                                                <th>Order Date</th>
                                                <th>Customer</th>
                                                <th>Address</th>
                                                <th>Status</th>
                                                <th>Payment Method</th>
                                                <th>Total Amount</th>
                                                {from === 'sales' && (<th>Action</th>)}
                                            </tr >
                                        </thead >
                                        <tbody>
                                            {Array.isArray(filteredData) && filteredData.length > 0 ? (
                                                filteredData.map((od, i) => {
                                                    const isShippingAdded = shippingDatas.some(shipping => shipping.orderId === od.orderId);
                                                    return (
                                                        <tr key={od.orderId}>
                                                            <td>{i + 1}</td>
                                                            <td className="cursor-pointer" onClick={() => { toggleFlyout(od, 'invoice') }}>{od.orderId}</td>
                                                            <td>{od.date}</td>
                                                            <td className="cursor-pointer" onClick={() => { toggleFlyout(od, 'customer') }}>{od.name}</td>
                                                            <td>
                                                                Phone no: {od.phoneNumber}
                                                                <br />
                                                                {od.address}
                                                                <br />
                                                                {od.city}
                                                                <br />
                                                                {od.state}
                                                            </td>
                                                            <td>{od.status}</td>
                                                            <td>{od.paymentMode}</td>
                                                            <td>{od.totalAmount}</td>
                                                            <td>
                                                                {from === 'sales' && (
                                                                    <>
                                                                        {isShippingAdded ?
                                                                            <button className="btn btn-success">
                                                                                Added to Shipping
                                                                            </button>
                                                                            :
                                                                            <button
                                                                                className="btn btn-primary"
                                                                                onClick={() => handleOpenModal(od.orderId, od.customerId, od.address, od.city, od.state)}
                                                                            >
                                                                                Add to Shipping
                                                                            </button>
                                                                        }
                                                                    </>
                                                                )}
                                                            </td >
                                                        </tr >
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="10" style={{ textAlign: 'center' }}>
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody >
                                    </table >
                                )}
                            </div >
                        </div >
                    </div >
                </div >
            </div >
        </SuperAdminHeader >

        {/* Shipping Modal */}
        < Modal Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Add Shipping Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>

<form>
  <div className="row">
    {/* Tracking Number */}
    <div className="form-group col-sm-6 mb-3">
      <label>Tracking Number</label>
      <input
        type="text"
        name="trackingNumber"
        value={shippingData.trackingNumber}
        onChange={handleChange}
        className={`form-control ${errors.trackingNumber ? 'is-invalid' : ''}`}
      />
      {errors.trackingNumber && errors.trackingNumber !== '' && (
  <small className="text-danger">{errors.trackingNumber}</small>
)}

    </div>

    {/* Carrier */}
    <div className="form-group col-sm-6 mb-3">
      <label>Carrier</label>
      <select
        name="carrier"
        value={shippingData.carrier}
        onChange={handleChange}
        className={`form-control ${errors.carrier ? 'is-invalid' : ''}`}
      >
        <option value="">Select Carrier</option>
        {settingsData
          ?.filter((sd) => sd.head === 'Shipping Methods')
          ?.map((sd) => (
            <option key={sd.key} value={sd.key}>
              {sd.key}
            </option>
          ))}
      </select>
      {errors.carrier && errors.carrier !== '' && (
  <small className="text-danger">{errors.carrier}</small>
)}

    </div>

    {/* Shipping Method */}
    <div className="form-group col-sm-6 mb-3">
      <label>Shipping Method</label>
      <select
        name="shippingMethod"
        value={shippingData.shippingMethod}
        onChange={handleChange}
        className={`form-control ${errors.shippingMethod ? 'is-invalid' : ''}`}
      >
        <option value="">Select Method</option>
        <option value="Standard">Standard</option>
        <option value="Express">Express</option>
        <option value="Next-Day">Next-Day</option>
        <option value="Economy">Economy</option>
      </select>
      {errors.shippingMethod && errors.shippingMethod !== '' && (
  <small className="text-danger">{errors.shippingMethod}</small>
)}
    </div>

    {/* Shipping Cost */}
    <div className="form-group col-sm-6 mb-3">
      <label>Shipping Cost</label>
      <input
        type="number"
        name="shippingCost"
        value={shippingData.shippingCost}
        onChange={handleChange}
        className={`form-control ${errors.shippingCost ? 'is-invalid' : ''}`}
      />
      {errors.shippingCost && errors.shippingCost !== '' && (
  <small className="text-danger">{errors.shippingCost}</small>
)}
    </div>

    {/* Loading Charge */}
    <div className="form-group col-sm-6 mb-3">
      <label>Loading Charge</label>
      <input
        type="number"
        name="loadingCharge"
        value={shippingData.loadingCharge}
        onChange={handleChange}
        className={`form-control ${errors.loadingCharge ? 'is-invalid' : ''}`}
      />
      {errors.loadingCharge && errors.loadingCharge !== '' && (
  <small className="text-danger">{errors.loadingCharge}</small>
)}
    </div>

    {/* Unloading Charge */}
    <div className="form-group col-sm-6 mb-3">
      <label>Unloading Charge</label>
      <input
        type="number"
        name="unloadingCharge"
        value={shippingData.unloadingCharge}
        onChange={handleChange}
        className={`form-control ${errors.unloadingCharge ? 'is-invalid' : ''}`}
      />
      {errors.unloadingCharge && errors.unloadingCharge !== '' && (
  <small className="text-danger">{errors.unloadingCharge}</small>
)}
    </div>

    {/* Address */}
    <div className="form-group col-sm-6 mb-3">
      <label>Address</label>
      <input
        type="text"
        name="address"
        value={shippingData.address}
        onChange={handleChange}
        className={`form-control ${errors.address ? 'is-invalid' : ''}`}
      />
      {errors.address && errors.address !== '' && (
  <small className="text-danger">{errors.address}</small>
)}
    </div>

    {/* City */}
    <div className="form-group col-sm-6 mb-3">
      <label>City</label>
      <input
        type="text"
        name="city"
        value={shippingData.city}
        onChange={handleChange}
        className={`form-control ${errors.city ? 'is-invalid' : ''}`}
      />
      {errors.city && errors.city !== '' && (
  <small className="text-danger">{errors.city}</small>
)}
    </div>

    {/* State */}
    <div className="form-group col-sm-6 mb-3">
      <label>State</label>
      <input
        type="text"
        name="state"
        value={shippingData.state}
        onChange={handleChange}
        className={`form-control ${errors.state ? 'is-invalid' : ''}`}
      />
      {errors.state && errors.state !== '' && (
  <small className="text-danger">{errors.state}</small>
)}
    </div>
  </div>
</form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Close
                </Button>
                <Button variant="warning" onClick={handleClear}>
                    Clear
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal >
        <ToastContainer position="top-right" />
    </>;
};

export default Invoice;
